module.exports = __webpack_public_path__ + "img/red.777a5192.svg";